class OwnerData {
  constructor({
    total_per_unit = null,
    total_removal = null,
    status = null,
    latitude = null,
    longitude = null,
    country = null,
    removal_per_month = null,
    project = null,
    info = null,
  }) {
    this.total_per_unit = total_per_unit;
    this.total_removal = total_removal;
    this.status = status;
    this.latitude = latitude;
    this.longitude = longitude;
    this.country = country;
    this.removal_per_month = removal_per_month;
    this.project = project;
    this.info = info;
  }
}

export default OwnerData;
